/**
 * Parse a SPA-formatted price string (e.g. "$19.99", "€19,99", "1,234.56")
 * into a plain "19.99"-shaped numeric string suitable for Klaviyo's $value /
 * Price / ItemPrice fields.
 */
export const parsePriceToNumeric = (input: any): string => {
  if (input === null || input === undefined) return "0.00";
  if (typeof input === "number" && isFinite(input)) return input.toFixed(2);
  const str = String(input);
  if (!str) return "0.00";
  const cleaned = str.replace(/[^0-9.,-]/g, "");
  if (!cleaned) return "0.00";
  const lastDot = cleaned.lastIndexOf(".");
  const lastComma = cleaned.lastIndexOf(",");
  let normalized = cleaned;
  if (lastComma !== -1 && lastComma > lastDot) {
    normalized = cleaned.replace(/\./g, "").replace(",", ".");
  } else {
    normalized = cleaned.replace(/,/g, "");
  }
  const n = parseFloat(normalized);
  return isFinite(n) ? n.toFixed(2) : "0.00";
};

/**
 * Best-effort absolute URL builder. If a storefront URL was configured in
 * admin and forwarded via klaviyoSettings, prepend it; otherwise fall back
 * to window.location.origin so emails still get a full URL.
 */
export const absoluteUrl = (
  storefrontUrl: string | undefined,
  path: string
): string => {
  const safePath = path.startsWith("/") ? path : `/${path}`;
  const base = (storefrontUrl || "").trim();
  if (base) return base.replace(/\/+$/, "") + safePath;
  if (
    typeof window !== "undefined" &&
    window.location &&
    window.location.origin
  ) {
    return window.location.origin + safePath;
  }
  return safePath;
};

export const safeParse = (value: string): any => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
};
